import { LeasingOffersPathsEnum } from 'modules/leasingOffersPage/routes';
import moment from 'moment';
import { Button, ButtonType } from 'modules/ui';
import { pdf } from '@react-pdf/renderer';
import { useAppDispatch } from 'modules/hooks/appHooks';
import { useTranslation } from 'react-i18next';
import { LeasingOffersDetailsThunks } from 'modules/leasingOfferOverviewPage/redux';
import { saveAs } from 'file-saver';
import { LeasingOffer, LeasingOfferDetails } from '../../types/LeasingOffer';
import { ExpiryWrapper } from '../../utils/tableCellCssUtils';
import { LeasingOfferPdf } from './LeasingOfferPdf';

export enum LeasingOffersKeys {
  Active = 'active-offers',
}

export const getLeasingOfferPageUrl = (tab: LeasingOffersKeys) =>
  `${LeasingOffersPathsEnum.leasingOffers}/${tab}`;

export const getOfferExpiryText = (leasingOffer: LeasingOffer) => {
  /* TODO - maybe add day amount to constants, read it from environment variable
   * or let the back-end return the expiry date */
  const expiryDate = moment(leasingOffer.creationDate, 'YYYY-MM-DD').add(
    7,
    'days',
  );

  if (expiryDate.isBefore()) {
    return '-';
  }

  const dayDiff = expiryDate.add(1, 'days').diff(moment(), 'days');

  return (
    <ExpiryWrapper accented={dayDiff <= 3}>
      {leasingOffer.daysUntilExpiration}
    </ExpiryWrapper>
  );
};

export const DownloadLeasingOfferDetails: React.FC<{
  leasingOfferId: number;
  localData?: LeasingOfferDetails;
  buttonType?: ButtonType;
  buttonText?: string;
  buttonIcon?: React.ReactNode;
}> = ({
  leasingOfferId,
  localData,
  buttonType = ButtonType.Action,
  buttonText,
  buttonIcon,
}) => {
  const dispatch = useAppDispatch();
  const { t } = useTranslation();

  const onClick = async () => {
    let offerData = localData;

    if (!offerData) {
      const response = await dispatch(
        LeasingOffersDetailsThunks.fetchLeasingOffersDetails({
          id: leasingOfferId,
        }),
      );
      offerData = response.payload;
    }

    const leasingOfferPdfDocument = (
      <LeasingOfferPdf leasingOfferDetails={offerData} />
    );
    const asPdfBlob = await pdf(leasingOfferPdfDocument).toBlob();
    saveAs(asPdfBlob, 'leasing-offer.pdf');
  };

  return (
    <Button
      type={buttonType}
      text={buttonText || t('tableButtons.download')}
      icon={buttonIcon}
      onClick={onClick}
    />
  );
};
